import React from 'react';
import FormulaFieldProto from '../formula-proto';


export default function renderFormulaInEdit(id, props) {
    return <FormulaFieldProto renderMode="edit" id={id} {...props} />;
}